<script lang="ts">
  /*                                                                              */
  /*                                                                                                                      */

  import BoxSizingBorderBox from "./BoxSizingBorderBox.svelte";
  import FitContentStyles from "./FitContentStyles.svelte";
  import InlineFillParentStyles from "./InlineFillParentStyles.svelte";

  let {
    contentBox = false,
    inline = false,
    widthBehavior = "fill",
  }: {
    /**
 *
 */
    contentBox?: boolean;
    /**
 *
 */
    inline?: boolean;
    /**
 *
 *
 *
 */
    widthBehavior?: "fill" | "fit";
  } = $props();
</script>

<!--prevent whitespace between elements for inline layout-->
<!-- prettier-ignore-start
-->{#if !contentBox}<!--
  --><BoxSizingBorderBox /><!--
-->{/if}<!--
-->{#if widthBehavior === "fit"}<!--
  --><FitContentStyles /><!--
-->{:else if widthBehavior === "fill" && inline}<!--
  --><InlineFillParentStyles /><!--
-->{/if}
<!-- prettier-ignore-end -->

<style lang="scss">
  @use "@otto-ec/otto-components-utils/scss/mixins";
  :global {
    * {
      letter-spacing: unset;
      line-height: unset;
      word-spacing: unset;
    }

    :host {
      @include mixins.no-tap-highlight();
    }
  }
</style>
